(function() {
  function hideFaellig() {
    document.querySelectorAll('div._1mrl40q0, div._1fragemby').forEach(function(el) {
      el.style.setProperty('display', 'none', 'important');
    });
  }

  document.addEventListener('DOMContentLoaded', hideFaellig);

  new MutationObserver(hideFaellig).observe(document.body, {
    childList: true, subtree: true
  });

  let count = 0;
  const interval = setInterval(function() {
    hideFaellig();
    count++;
    if (count >= 20) clearInterval(interval);
  }, 500);
})();
